// src/components/ProtectedRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children, allowGuests = true }) => {
  const token = localStorage.getItem("token");
  const isGuest = localStorage.getItem("is_guest") === "true";

  // Token yoksa → login sayfasına yönlendir
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // Eğer misafir ise ve bu route misafire yasaklı ise → anasayfaya yönlendir
  if (isGuest && !allowGuests) {
    return <Navigate to="/" replace />;
  }

  // Aksi halde çocuk bileşeni render et
  return children;
};

export default ProtectedRoute;
